import { render, staticRenderFns } from "./ordertimelimitconfig-add-and-update.vue?vue&type=template&id=0cd0e939"
import script from "./ordertimelimitconfig-add-and-update.vue?vue&type=script&lang=js"
export * from "./ordertimelimitconfig-add-and-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd0e939')) {
      api.createRecord('0cd0e939', component.options)
    } else {
      api.reload('0cd0e939', component.options)
    }
    module.hot.accept("./ordertimelimitconfig-add-and-update.vue?vue&type=template&id=0cd0e939", function () {
      api.rerender('0cd0e939', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/ordertimelimitconfig/ordertimelimitconfig-add-and-update.vue"
export default component.exports